export default __webpack_public_path__ + "static/media/sl1.a64a3617.png";